import React, { useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewcCasetable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import { useNavigate } from "react-router-dom";
import UserFilterList from "../../shared/UserFilterList ";
import { TableLoader } from "../../../../library/common/Loader";
import { PAGE_SIZE, ROW_PER_PAGE_SIZE } from "../../../../constant/constant";
import {
  ADMIN_CONTRACTOR,
  ADMIN_CONTRACTOR_DETAILS,
  ADMIN_SAFETY_LOG,
} from "../../../../constant/routeContant";
import DialogBox from "../../../../library/common/DialogBox";
import NORow from "../../../../library/custom/noRow/noRow";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import { InactiveClient } from "../../../../utils/helper";
import check_Icon from "../../..../../../../assets/check_Icon.svg";
import cross_Icon from "../../..../../../../assets/cross_Icon.svg";
import verifyEmailCheckBox from "../../..../../../../assets/verifyEmailCheckBox.svg";
import { Grid } from "@mui/material";

function ContractorTable({
  contractorGrades,
  deleteList,
  loading,
  getContractorListData,
  contractorListData,
  loadingContractor,
  filterShow = true,
  contractorTypes,
  isShowDowdownloadButton = true,
  setClickVerifyBtn,
  sendBulkEmailVarifation,
  setAccessUserId,
  accessUserId,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const [searchlocation, setSearchlocation] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const navigate = useNavigate();
  const [company, setCompany] = useState("");
  const [type, setType] = useState("");
  const [isTableLoading, setisTableLoading] = useState(false);
  //const [accessUserId, setAccessUserId] = useState([]);
  const deletehandle = () => {
    if (InactiveClient()) return;
    setOpenModal(false);
    deleteList(selectedRow.id);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
    const data = {
      page: 1,
      pageSize: pageSize,
      search: searchText ? searchText : "",
      gradeId: company,
      divisionId: 0,
      type: type,
      isSendMail: false,
    };

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getContractorListData(data);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    const data = {
      page: page,
      pageSize: newPazeSize,
      search: search,
      gradeId: company,
      divisionId: 0,
      type: type,
      isSendMail: false,
    };

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getContractorListData(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage + 1);
    const data = {
      page: newPage + 1,
      pageSize: pageSize,
      search: search,
      gradeId: company,
      divisionId: 0,
      type: type,
      isSendMail: false,
    };
    getContractorListData(data);
  };

  const handleViewOnClick = (rows) => {
    navigate(ADMIN_CONTRACTOR_DETAILS, {
      state: { rowsss: rows.row, editMode: false },
    });
  };

  const handleOnclick = (rows) => {
    if (InactiveClient()) return;
    navigate(ADMIN_CONTRACTOR, {
      state: {
        contractorId: rows.row.id,
        userId: rows.row.userId,
        editMode: true,
      },
    });
  };
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteIncidents = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };

  const safetyLogOnClick = (rows) => {
    navigate(ADMIN_SAFETY_LOG, {
      state: { userId: rows.row, userSafetyLog: true },
    });
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.8 },
    {
      field: "contractorName",
      headerName: "Sub-Contractor Name",
      flex: 1.6,
    },
    // { field: "pocFirstName", headerName: "First Name", flex: 1.5 },
    // { field: "pocLastName", headerName: "Last Name", flex: 1.5 },
    {
      field: "pointOfContactName",
      headerName: "Point of Contact Name",
      type: "text",
      flex: 1.8,
      minWidth: 90,
      // renderCell: (cellValues) => {
      //   return (
      //     <>
      //       {cellValues?.row?.pocFirstName + " " + cellValues?.row?.pocLastName}
      //     </>
      //   );
      // },
    },
    {
      field: "email",
      headerName: "Email ID",
      flex: 3.3,
      renderCell: (rows) => {
        const email = rows?.row?.email || "";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              width: "100%",
            }}
          >
            <div
              title={email}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
                minWidth: "0",
                textAlign: "left",
              }}
            >
              {email}
            </div>
          </div>
        );
      },
    },
    {
      field: "isEmailVerified",
      headerName: "Verified Email",
      flex: 1.5,
      renderCell: (rows) => {
        return rows?.row?.isEmailVerified ? (
          <img src={check_Icon} alt="Verified" width="16" height="16" />
        ) : (
          <img src={cross_Icon} alt="Not Verified" width="18" height="18" />
        );
      },
    },
    { field: "contractorType", headerName: "Type", flex: 1 },
    { field: "grade", headerName: "Grade", flex: 0.8 },

    {
      field: "",
      width: 68,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return filterShow ? (
          <ReportRowManipulte
            rows={rows}
            viewOnClick={() => handleViewOnClick(rows)}
            editOnClick={() => handleOnclick(rows)}
            viewLabel="View Details"
            deleteOnClick={() => deleteIncidents(rows?.row)}
            edit={checkPrivileges([12, 43, 44])}
            editLabel="Edit Contractor"
            download={false}
            view={checkPrivileges([12, 43, 44, 45])}
            deleted={checkPrivileges([12, 43])}
            deleteLabel="Delete Contractor"
            safetyLogLabel="Safety Log"
            safetyLogOnClick={() => safetyLogOnClick(rows)}
            safetyLog={checkPrivileges([12, 43, 44, 45])}
          />
        ) : (
          ""
        );
      },
    },
  ];

  const companyOnChanges = (e) => {
    setCompany(e.target.value);
  };

  const handleSearch = () => {
    setAnchorEl(null);
    window.close();
    const data = {
      page: 1,
      pageSize: pageSize,
      search: search,
      gradeId: company,
      divisionId: 0,
      type: type,
      isSendMail: false,
    };

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getContractorListData(data);
  };
  const handleClear = () => {
    setCompany("");
    setType("");
    setAnchorEl(null);
    window.close();
    setSearch("");
    const defaultData = {
      page: 1,
      pageSize: pageSize,
      search: "",
      gradeId: "",
      divisionId: 0,
      type: "",
      isSendMail: false,
    };

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getContractorListData(defaultData);
  };

  const onRowClick = (rows) => {
    if (rows.value) {
      navigate(ADMIN_CONTRACTOR_DETAILS, {
        state: { rowsss: rows.row, editMode: false },
      });
    }
  };

  const sendEmail = () => {
    const data = {
      page: page,
      pageSize: pageSize,
      search: search,
      gradeId: company,
      divisionId: 0,
      type: type,
      isSendMail: true,
    };
    getContractorListData(data);
  };

  const sendBulkEmailVerify = () => {
    if (accessUserId?.length > 0) {
      setClickVerifyBtn(true);
      const data = {
        ids: accessUserId,
        type: 1,
      };
      sendBulkEmailVarifation(data);
    }
  };

  return (
    <>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          {openModal && (
            <DialogBox
              open={openModal}
              rows={[]}
              deletehandle={deletehandle}
              handleCloseModal={() => setOpenModal(false)}
              view
              content={"Are you sure you want to delete this Contractor?"}
            />
          )}
        </div>
        <div className={accessUserId?.length > 0 ? "userMain" : ""}>
          {" "}
          <div className="grid_main_body">
            <Grid
              container
              className="fixedDesign div-filter-container gapNone"
            >
              <Grid item sm={6} md={6} xs={12}>
                <div className="filter_of_caselist">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>
                  {filterShow && (
                    <div className="filter_btn">
                      <button
                        aria-describedby={id}
                        variant="contained"
                        type="button"
                        name="btn"
                        onClick={(e) => handleClick(e)}
                      >
                        <FilterListIcon id="icn" /> Filters
                      </button>
                      {/* <FilterButton
                label={"Filters"}
                handleClick={(e) => handleClick(e)}
              /> */}
                      <UserFilterList
                        firstLabel="Grade"
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        searchlocation={searchlocation}
                        setSearchlocation={setSearchlocation}
                        handleApply={handleSearch}
                        firstLebelFilter={contractorGrades}
                        firstLebelOnChanges={companyOnChanges}
                        firstLebelValue={company}
                        secondLebelFilter={contractorTypes}
                        secondLebelOnChanges={(e) => setType(e.target.value)}
                        secondLabel={"Type"}
                        secondLebelValue={type}
                        handleClear={handleClear}
                        resetBtn={true}
                        isShow={true}
                      />
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item sm={6} md={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item md={7} xs={12} className="emailRight">
                    {accessUserId?.length > 0 && (
                      <div
                        className={`div-verify-email-right ${
                          accessUserId?.length === 0 ? "asscssuser" : ""
                        }`}
                        onClick={sendBulkEmailVerify}
                      >
                        <span>
                          <img
                            src={verifyEmailCheckBox}
                            className="DownLoadLogo"
                            alt="DownLoad Logo"
                          />
                        </span>
                        Verify Selected Emails
                      </div>
                    )}
                  </Grid>
                  <Grid item md={5} xs={12}>
                    {isShowDowdownloadButton && (
                      <div
                        className="div-download-email-right"
                        onClick={sendEmail}
                      >
                        <span>
                          <img
                            src={downloadIcon}
                            className="DownLoadLogo"
                            alt="DownLoad Logo"
                          />
                        </span>
                        Download Data
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <ViewcCasetable
                    getRowId={(r) => r?.userId}
                    rows={contractorListData?.result?.contractorData || []}
                    rowCount={contractorListData?.result?.noOfRecords || 0}
                    columns={columns}
                    // onClick={(rows) => onRowClick(rows)}
                    loading={loading || loadingContractor}
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                    checkboxSelection={true}
                    page={page}
                    pagination
                    pageSize={pageSize}
                    rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                    onPageSizeChange={handlePageSizeChange}
                    onPageChange={handlePagignation}
                    backIconButtonProps={{ disabled: false }}
                    disableSelectionOnClick
                    isRowSelectable={(params) =>
                      params?.row?.isEmailVerified === false
                    }
                    onSelectionModelChange={setAccessUserId}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default ContractorTable;
